export default __webpack_public_path__ + "static/media/steam-cleaning-1000px.c5545a01.jpg";